import { render, staticRenderFns } from "./Redazioni.vue?vue&type=template&id=722f535f"
import script from "./Redazioni.vue?vue&type=script&lang=js"
export * from "./Redazioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports